import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import "jquery/plugins/jquery.validate";

$(document).ready(function(){
	if (!Abacus.PreventDefault.FormValidation){
		Abacus.FormValidator = new FormValidator();
	}
});

let FormValidatorOptions = {
	validateSelectors: ['form.validation'], // Allow validation for these forms
	noValidateSelectors: [], // ['.abacusPopup form', '.signIn form', '.emailfriend form'] used to prevent form validation e.g in popups or bespoke forms unless you want it
	validationOptions: { // This comes from jquery validation plugin
		onfocusout: false,
		onkeyup: false,
		onclick: false,
		ignoreTitle: true,
		errorElement: "p",
		success: function(label) {
			label.closest('.errorbox').remove();
		},
		errorPlacement: function(error, element) {
			$(element).closest('div:not(.inputSleeve)').find('.errorbox').remove();
			$(element).closest('div:not(.inputSleeve)').prepend(error);
			error.wrap("<div class='errorbox'><div class='errorbox_sleeve'></div></div>");
			$(error).attr('aria-labelledby', element[0].id);
		},
		debug: true,
		invalidHandler: function(event, validator) {
			$(validator.currentForm).removeClass('valid').addClass('invalid');
		},
		submitHandler: function(form) {  
			// this function gets overwritten in ajax form calls - popup.class.js
			var $form = $(form);
			if ($form.valid()) {
				$form.removeClass('invalid').addClass('valid');
				form.submit(); 
				return false; // prevent normal form posting
			}
		}
	}
};

class FormValidator extends Class{

	constructor(options){
		super();
		this.setOptions(FormValidatorOptions, options);
		this.element = this.options.validateSelectors;
		if(this.options.validateSelectors.length !== 0) this.init();
		this.setupEvents();
	}

	init() {
		var self = this;
		$.each(self.element, function(i, element){
			$(element).each(function(){
				self.validateForm(this, self.options.validationOptions);
			});
		});
		this.preventFormValidation();
	}

	preventFormValidation(form, options) {
		$.each(this.options.noValidateSelectors, function(i, element) {
			$(element).off('submit');
		});
	}

	validateForm(form, options) {
		$(form).validate(options);
	}

	addAjaxFormClass(form) { // used for popups
		if(form.valid()) {
			form.removeClass('invalid').addClass('valid');
		} else {
			form.removeClass('valid').addClass('invalid');
		}
	}

	setupEvents() {
		var self = this;
		$(window).on('abacus:validateForm', function(event, form, options){
			var newOptions = $.extend({}, self.options.validationOptions, options);
			self.validateForm(form, newOptions);
			self.addAjaxFormClass($(form));
			self.preventFormValidation();
		});
	}
}

$.validator.addMethod("uploadlimit", function(value, element) {
	return this.optional(element) || !element.files || element.files[0].size < 3145727;
}, "File is too large. Please choose a file lower than 3MB");

export { FormValidator };


// WEBPACK FOOTER //
// ./Javascript/core/classes/form.validator.class.js